import React from "react";

export default function PATHeadersection() {
  return (
    <div className={Classname.container}>
      <div className={Classname.profile}>
        {/* <div className={Classname.bold}>Payment & tax details</div> */}
        {/* <div className={Classname.supplier}>
          <div>Supplier ID:</div>
          <div className={Classname.supplierID}>38901</div>
        </div> */}
      </div>
    </div>
  );
}

const Classname = {
  container: "flex flex-col gap-2 p-2",
  profile: "flex justify-between mt-4 mb-6",
  bold: "font-bold text-lg",
  supplier: "flex gap-4",
  supplierID: "font-bold",
};
